<script lang="ts">
	export let text: string = '';
	export let iconString: string = '';
	export let enable = true;
	export let type: 'primary' | 'secondary' | 'outlined' = 'primary';

	let className = '';
	export { className as class };
</script>

{#if enable}
	<div
		role="button"
		tabindex="0"
		data-testid={`button-${text}`}
		class="cursor-pointer flex items-center {className} {type}"
		on:click
		on:keypress
	>
		{#if iconString}
			<svg
				class="h-4 w-4 mr-1 dark:text-white"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
			>
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d={iconString} />
			</svg>
		{/if}
		<button tabindex="-1">
			<slot>{text}</slot>
		</button>
	</div>
{:else}
	<div data-testid={`button-${text}`} class="flex items-center {className} {type} {type}-disabled">
		{#if iconString}
			<svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d={iconString} />
			</svg>
		{/if}
		<button>
			<slot>{text}</slot>
		</button>
	</div>
{/if}

<style>
	button {
		border: none;
	}
	.primary-disabled {
		border-radius: 6px;
		border: 2px solid rgba(173, 173, 173, 0.3);
		background: linear-gradient(180deg, #212121 0%, #2b2b2b 100%);

		/* 버튼 비활성효과 */
		box-shadow: 0px 6px 0px 0px #202020, 0px 0px 20px 0px rgba(56, 56, 56, 0.6) inset;
	}
	:global(.primary) {
		display: flex;
		justify-content: center;
		align-items: center;

		border-radius: 6px;
		border: 2px solid rgba(255, 255, 255, 0.5);
		background: var(--p-60, #49b4b1);
		/* 버튼 디폴트효과 */
		box-shadow: 0px 6px 0px 0px #378785, 0px 0px 20px 0px rgba(222, 249, 248, 0.5) inset;
	}
	.secondary-disabled {
		border-radius: 6px;
		border: 2px solid rgba(173, 173, 173, 0.3);
		background: linear-gradient(180deg, #212121 0%, #2b2b2b 100%);

		/* 버튼 비활성효과 */
		box-shadow: 0px 6px 0px 0px #202020, 0px 0px 20px 0px rgba(56, 56, 56, 0.6) inset;
	}
	:global(.secondary) {
		display: flex;
		justify-content: center;
		align-items: center;

		border-radius: 6px;
		border: 2px solid rgba(255, 255, 255, 0.5);
		background: var(--p-70, #378785);

		/* 버튼 호버효과 */
		box-shadow: 0px 3px 0px 0px #378785, 0px 0px 20px 0px rgba(157, 237, 235, 0.5) inset;
	}
	:global(.outlined) {
		display: flex;
		justify-content: center;
		align-items: center;

		border-radius: 6px;
		border: 2px solid var(--p-60, #49b4b1);
		background: var(--bg, #151516);
		box-shadow: 0px 6px 0px 0px #378785;
	}
	:global(.outlined:hover) {
		background: linear-gradient(
			90deg,
			var(--secondary-600-color) 0%,
			var(--secondary-400-color) 100%
		);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
</style>
